const autoNgTemplateLoaderTemplate1 = require('./containerGroupsDatatable.html');

angular.module('portainer.azure').component('containergroupsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
  },
});
